import { AttributeTypeError } from "./errors.js";
const stringConverter = {
  fromAttribute(value) {
    return value ?? void 0;
  },
  toAttribute(value) {
    return value;
  }
};
const numberConverter = {
  fromAttribute(value, attributeName) {
    if (value === null) return void 0;
    if (value.trim() === "") {
      throw new AttributeTypeError(attributeName, "number", value);
    }
    const num = Number(value);
    if (Number.isNaN(num)) {
      throw new AttributeTypeError(attributeName, "number", value);
    }
    return num;
  },
  toAttribute(value) {
    return String(value);
  }
};
const booleanConverter = {
  fromAttribute(value) {
    if (value === null) return void 0;
    if (value === "false") return false;
    return true;
  },
  toAttribute(value) {
    return value ? "" : null;
  }
};
const objectConverter = {
  fromAttribute(value, attributeName) {
    if (value === null) return void 0;
    try {
      return JSON.parse(value);
    } catch {
      throw new AttributeTypeError(attributeName, "object", value);
    }
  },
  toAttribute(value) {
    return JSON.stringify(value);
  }
};
const arrayConverter = {
  fromAttribute(value, attributeName) {
    if (value === null) return void 0;
    let parsed;
    try {
      parsed = JSON.parse(value);
    } catch {
      throw new AttributeTypeError(attributeName, "array", value);
    }
    if (!Array.isArray(parsed)) {
      throw new AttributeTypeError(attributeName, "array", value);
    }
    return parsed;
  },
  toAttribute(value) {
    return JSON.stringify(value);
  }
};
const Converters = {
  string: stringConverter,
  number: numberConverter,
  boolean: booleanConverter,
  object: objectConverter,
  array: arrayConverter
};
function resolveConverter(typeOrConverter) {
  if (typeof typeOrConverter === "string") {
    return Converters[typeOrConverter];
  }
  return typeOrConverter;
}
export {
  Converters,
  resolveConverter
};
//# sourceMappingURL=converters.js.map
